import React, { useEffect } from 'react';
import { useLocation } from 'react-router';

import { LocalStorageKey, localStorageUtil } from '@/utils/localStorage/localStorage.util.ts';

export const HistoryController: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const history = localStorageUtil.getItem<string[]>({ key: LocalStorageKey.HISTORY });
    if (!history) {
      localStorageUtil.setItem({ key: LocalStorageKey.HISTORY, value: [location.pathname] });
      return;
    }
    if (history[0] === location.pathname) {
      return;
    }
    history.unshift(location.pathname);
    const newHistory = history.slice(0, 2);
    localStorageUtil.setItem({ key: LocalStorageKey.HISTORY, value: newHistory });
  }, [location.pathname]);

  return null;
};
